import { RootState } from '@src/state/types'
import { getFilename, getUploadId } from '@src/state/workspace/selectors'
import { getCurrentLocale } from '@src/utils/locale'
import { convertToRaw } from 'draft-js'
import { createSelector } from 'reselect'
import { CheckState } from '../checks/reducer'
import { DocumentState } from '../document/reducer'
import { WfeLS } from './types'

export const getStateToPersist = createSelector<
  RootState,
  string,
  string,
  CheckState,
  DocumentState,
  WfeLS
>(
  [
    getFilename,
    getUploadId,
    (state: RootState) => state.checks,
    (state: RootState) => state.document,
  ],
  (filename, uploadId, checks, document) => {
    const { plagiarismScore, version, comments } = document
    return {
      filename,
      rawContentState: convertToRaw(document.editorState.getCurrentContent()),
      uploadId,
      checks,
      selectedLocale: getCurrentLocale(),
      version,
      plagiarismScore,
      comments,
    }
  }
)



// WEBPACK FOOTER //
// ./src/state/session/selectors.ts